import { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

import { HorizontalAlignment } from '../../../types/alignmentTypes'

import './TableCell.scss'

interface TableCellProps extends PropsWithChildren {
    align?: HorizontalAlignment;
    colSpan?: number;
    contentClassName?: string;
    className?: string;
}

const TableCell: FC<TableCellProps> = ({
    align,
    colSpan,
    contentClassName = '',
    className = '',
    children,
}): ReactElement => {
    const tableCellClassNames = classNames('table-cell', {
        [`table-cell--align-${align}`]: align,
    }, className)

    return (
        <td colSpan={colSpan} className={tableCellClassNames}>
            <span className={`table-cell__content-wrapper ${contentClassName}`}>
                {children}
            </span>
        </td>
    )
}

export default TableCell
